'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadLanguageList = exports.setLanguageList = exports.loadTranslations = exports.setLanguageKey = exports.loadTranslationsWithCheck = exports.changeLanguage = exports.setTranslationList = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _rtlDetect = require('rtl-detect');

var _rtlDetect2 = _interopRequireDefault(_rtlDetect);

var _i18n = require('../constants/i18n');

var _i18n2 = require('../selectors/i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var setLanguageKey = function setLanguageKey(languageKey) {
    return {
        payload: languageKey,
        type: _i18n.ACTION_TYPES.SET_LANGUAGE_KEY
    };
};

var setTranslationList = function setTranslationList(translationData) {
    return {
        payload: translationData,
        type: _i18n.ACTION_TYPES.SET_TRANSLATION_LIST
    };
};

var setLanguageList = function setLanguageList(languageList) {
    return {
        payload: languageList,
        type: _i18n.ACTION_TYPES.SET_LANGUAGE_LIST
    };
};

function loadTranslations(languageKey) {
    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
            var dataLoader = _ref2.dataLoader;

            var _ref3, data, errors;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return dataLoader.loadTranslations(languageKey);

                        case 2:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            errors = _ref3.errors;


                            if (!errors) {
                                dispatch(setTranslationList({
                                    languageKey: languageKey,
                                    translationList: data
                                }));
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function (_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }();
}

function loadTranslationsWithCheck(languageKey) {
    var _this = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if ((0, _i18n2.selectTranslationList)(getState(), languageKey)) {
                                _context2.next = 3;
                                break;
                            }

                            _context2.next = 3;
                            return dispatch(loadTranslations(languageKey));

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function loadLanguageList() {
    var _this2 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref6) {
            var dataLoader = _ref6.dataLoader;

            var _ref7, data, errors, normData;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return dataLoader.loadLanguageList();

                        case 2:
                            _ref7 = _context3.sent;
                            data = _ref7.data;
                            errors = _ref7.errors;


                            if (!errors) {
                                normData = Object.entries(data).reduce(function (list, _ref8) {
                                    var _ref9 = _slicedToArray(_ref8, 2),
                                        code = _ref9[0],
                                        lngData = _ref9[1];

                                    list[code] = _extends({}, lngData, {
                                        code: code,
                                        dir: _rtlDetect2.default.getLangDir(code)
                                    });

                                    return list;
                                }, {});


                                dispatch(setLanguageList(normData));
                            }

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }));

        return function (_x6, _x7, _x8) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function changeLanguage(languageKey) {
    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var state, currentLanguageKey, direction, htmlNode;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            currentLanguageKey = (0, _i18n2.selectLanguageKey)(state);

                            if (!(currentLanguageKey !== languageKey)) {
                                _context4.next = 9;
                                break;
                            }

                            _context4.next = 5;
                            return dispatch(loadTranslationsWithCheck(languageKey));

                        case 5:
                            dispatch(setLanguageKey(languageKey));

                            direction = (0, _i18n2.selectLanguageDir)(state, languageKey);
                            htmlNode = document.querySelector('html');


                            if (htmlNode) {
                                htmlNode.setAttribute('lang', languageKey);
                                htmlNode.setAttribute('dir', direction);
                            }

                        case 9:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        return function (_x9, _x10) {
            return _ref10.apply(this, arguments);
        };
    }();
}

exports.setTranslationList = setTranslationList;
exports.changeLanguage = changeLanguage;
exports.loadTranslationsWithCheck = loadTranslationsWithCheck;
exports.setLanguageKey = setLanguageKey;
exports.loadTranslations = loadTranslations;
exports.setLanguageList = setLanguageList;
exports.loadLanguageList = loadLanguageList;